import { render, staticRenderFns } from "./NewsComponent.vue?vue&type=template&id=6e49fe38&scoped=true&"
import script from "./NewsComponent.vue?vue&type=script&lang=js&"
export * from "./NewsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsComponent.vue?vue&type=style&index=0&id=6e49fe38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e49fe38",
  null
  
)

export default component.exports